import React from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeType } from '../../../types/command';
import SectionWrapper from '../../shared/SectionWrapper';
import { SectionTitle, SectionPrompt } from '../styles';
import styled from 'styled-components';
import { themeTokens } from '../../../styles/theme';

const AboutText = styled.p<{ $themeName: ThemeType }>`
  font-size: 16px;
  line-height: 1.8;
  color: ${({ $themeName }) => themeTokens[$themeName].textSecondary};
  margin: 0;
  max-width: 800px;
`;

interface AboutProps {
  themeName: ThemeType;
}

const About: React.FC<AboutProps> = ({ themeName }) => {
  const { t } = useTranslation();

  return (
    <SectionWrapper id="about" themeName={themeName}>
      <SectionPrompt $themeName={themeName}>$ cat about.md</SectionPrompt>
      <SectionTitle $themeName={themeName}>{t('ClassicPage.about.title')}</SectionTitle>
      <AboutText $themeName={themeName}>{t('ClassicPage.about.content')}</AboutText>
    </SectionWrapper>
  );
};

export default About;
